export interface RequestedClassAmount {
  RequestedClassId: string | null;
  RequestedClassName: string;
  RequestedClassType: string;
  Amount: number;
  VPJobID: string;
}
